import { IMAGES, MAGAZINE } from "../../data/content";

export const MagazineTicker = () => {
  const items = [...MAGAZINE.ticker, ...MAGAZINE.ticker];
  return (
    <a
      data-testid="magazine-ticker"
      href={MAGAZINE.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Apri Legend Magazine, la testata giornalistica del Legend Team"
      className="group flex items-stretch bg-red-600 text-white border-y border-red-700 overflow-hidden"
    >
      <span className="shrink-0 flex items-center gap-3 px-4 sm:px-6 bg-white z-10">
        <img
          data-testid="magazine-ticker-logo"
          src={IMAGES.logoMagazine}
          alt="Legend Magazine"
          className="h-6 sm:h-7 w-auto"
        />
        <span className="hidden sm:inline font-display text-[10px] font-black uppercase tracking-widest text-red-600 border-l border-neutral-300 pl-3">
          Breaking
        </span>
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track flex items-center h-10 sm:h-11 whitespace-nowrap will-change-transform group-hover:[animation-play-state:paused]">
          {items.map((t, i) => (
            <span key={i} className="mono-label text-xs sm:text-sm font-bold uppercase tracking-wider px-8">
              {t} <span className="text-black/60 ml-8">legendmagazine.it</span>
            </span>
          ))}
        </div>
      </div>
    </a>
  );
};
